/**
 * Where the management API lives. The inspector is served from the same origin
 * as the API, so every call is relative and this is the only place that knows
 * about the version.
 *
 * The unversioned `/api` still answers identically, but the inspector is the
 * one client we control end to end — there is no reason for it to keep calling
 * a prefix we are telling everyone else to leave.
 */
export const API_PREFIX = '/api/v1';
